import { render, staticRenderFns } from "./ScrollableTopBar.vue?vue&type=template&id=515d1a8f&scoped=true&"
import script from "./ScrollableTopBar.vue?vue&type=script&lang=ts&"
export * from "./ScrollableTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollableTopBar.vue?vue&type=style&index=0&id=515d1a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d1a8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('515d1a8f', component.options)
    } else {
      api.reload('515d1a8f', component.options)
    }
    module.hot.accept("./ScrollableTopBar.vue?vue&type=template&id=515d1a8f&scoped=true&", function () {
      api.rerender('515d1a8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/ScrollableTopBar.vue"
export default component.exports